import React from "react";

export default function SchoolbookTab() {
  return <div>SchoolbookTab</div>;
}
